import { createSlice } from '@reduxjs/toolkit';
import { pushProject } from '../apis/pushProject';
import { authorizeExisting, authorizeNew } from '../apis/authorization';
import { ApiStatus } from '@gift/types/generic/ApiStatus';

export const { actions, reducer } = createSlice({

    name: 'project',

    initialState: {

        authStatus: 'ready' as ApiStatus,
        jwt: null as string | null,
        privateId: null as string | null,

        pushStatus: 'ready' as ApiStatus,
        snapshotIds: [] as string[]
    },

    reducers: {},

    extraReducers: builder => {

        builder
            .addCase(pushProject.pending, state => void (state.pushStatus = 'pending'))
            .addCase(pushProject.rejected, state => void (state.pushStatus = 'error'));

        builder.addCase(pushProject.fulfilled, (state, action) => {
            state.pushStatus = 'ready';
            state.snapshotIds.push(action.payload.snapshotId);
        });

        for (const authorizer of [authorizeNew, authorizeExisting]) {

            builder
                .addCase(authorizer.pending, state => void (state.authStatus = 'pending'))
                .addCase(authorizer.rejected, state => void (state.authStatus = 'error'));

            builder.addCase(authorizer.fulfilled, (state, action) => {
                state.authStatus = 'ready';
                state.jwt = action.payload.jwt;
                state.privateId = action.payload.privateId;
            });
        }
    }
});